import React from 'react';
import {noop} from 'lodash';

import ReportCardSubheading from '/component/base/ReportCardSubheading';
import Text from '/component/base/Text';
import OrderHistoryReportContent from '/component/partial/reportCard/OrderHistoryReportContent';
import {UserProfileModal} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {getDateUtilDefaultInstance} from '/util/date.util';

interface PremierCancellationsReportContentProps {
  tt: (key: string, defaultText?: string) => string;
  recordData: {
    cancelledPremierOn: string;
    // Add any other properties from recordData if necessary
  };
  onOrderPress: () => void;
}

const PremierCancellationsReportContent: React.FC<
  PremierCancellationsReportContentProps
> = ({
  tt = withTranslation.ttDefaultProp, // Default translation function
  recordData = {cancelledPremierOn: ''}, // Default recordData
  onOrderPress = noop, // Default noop function for onOrderPress
}) => {
  const {cancelledPremierOn} = recordData;

  return (
    <>
      <ReportCardSubheading
        label={tt('label.cancellationDate', 'Cancellation Date')}
        value={
          <Text
            variant="large"
            testID={UserProfileModal.premierCancellationDate}>
            {getDateUtilDefaultInstance().formatDate(
              cancelledPremierOn,
              'MMMM d, yyyy',
            )}
          </Text>
        }
      />
      <OrderHistoryReportContent
        // @ts-expect-error TS(2769): No overload matches this call.
        recordData={recordData}
        onOrderPress={onOrderPress}
      />
    </>
  );
};

export default withTranslation('report.premierCancellations.content')(
  PremierCancellationsReportContent,
);
